<template>
  <tab-frame class="container">
    <mt-search
      v-model="condition.keyword"
      cancel-text="取消"
      placeholder="搜索主体名称、公证书编号"
    ></mt-search>
    <mt-navbar v-model="condition.applyStatus">
      <mt-tab-item
        v-for="status in applyStatusMap"
        :key="status.code"
        :id="status.code"
      >
        {{ status.label }}
      </mt-tab-item>
    </mt-navbar>
    <mt-tab-container v-model="condition.applyStatus" swipeable>
      <mt-tab-container-item
        v-for="status in applyStatusMap"
        :key="status.code"
        :id="status.code"
      >
        <mt-loadmore
          :top-method="refresh"
          topPullText=""
          topDropText=""
          topLoadingText=""
          :ref="'loadmore' + status.code"
          wxscrollable
          class="loadmore"
        >
          <div
            v-infinite-scroll="searchApplyList"
            infinite-scroll-distance="10"
            v-if="status.code === condition.applyStatus"
          >
            <mt-cell
              v-for="apply in applyList"
              :key="apply.guid"
              :title="apply.seller"
              :label="apply.time"
              :to="`/apply/detail?applyGuid=${apply.guid}`"
              is-link
            >
              <div slot="title" class="cell-title">
                <img
                  class="logo"
                  :src="getLogo(apply.origin)"
                />
                <div class="wrapper">
                  <span class="title">{{ apply.seller }}</span>
                  <span class="desc">{{ apply.time }}</span>
                </div>
              </div>
            </mt-cell>
            <div class="bottom-loading">
              <template v-if="!allLoaded">
                <mt-spinner type="fading-circle" :size="22"></mt-spinner>
              </template>
              <template v-else>
                <span class="text">——已加载全部——</span>
              </template>
            </div>
          </div>
        </mt-loadmore>
      </mt-tab-container-item>
    </mt-tab-container>
  </tab-frame>
</template>

<script>
import applyStatusMap from "@/assets/applyStatusMap";
const PAGE_SIZE = 15;
export default {
  name: "AppySearch",
  data() {
    return {
      dateStart: "",
      applyStatusMap,
      condition: {
        keyword: "",
        applyStatus: this.$store.state.applyStatus,
        pageNo: 1,
        pageSize: PAGE_SIZE,
        pageTotal: 1,
      },
      applyList: [],
      loading: false,
    };
  },
  computed: {
    allLoaded() {
      return this.condition.pageNo > this.condition.pageTotal;
    },
  },
  watch: {
    "condition.applyStatus"(value) {
      this.$store.commit("setApplyStatus", value);
      this.resetSearch();
      this.searchApplyList();
    },
    "condition.keyword"() {
      this.resetSearch();
      this.searchApplyList();
    },
  },
  methods: {
    getLogo(origin) {
      try {
        // eslint-disable-next-line no-undef
        return require(`@/assets/logo_` + origin + `.png`);
      } catch (e) {
        // eslint-disable-next-line no-undef
        return require(`@/assets/logo_default.png`);
      }
    },
    resetSearch() {
      this.applyList = [];
      this.condition = {
        ...this.condition,
        pageNo: 1,
        pageSize: PAGE_SIZE,
        pageTotal: 1,
      };
    },
    async refresh() {
      this.resetSearch();
      await this.searchApplyList();
      this.$refs["loadmore" + this.condition.applyStatus][0].onTopLoaded();
    },
    async searchApplyList() {
      if (this.loading || this.allLoaded) return;
      this.loading = true;
      try {
        let res = await this.$axios.get(`/applycheck/applylist`, {
          params: {
            applyStatus: this.condition.applyStatus,
            pageNo: this.condition.pageNo,
            pageSize: this.condition.pageSize,
            keyword: this.condition.keyword,
          },
        });
        this.condition.pageTotal = res.data.pagination.pageTotal;
        this.condition.pageNo = res.data.pagination.pageNo + 1;
        this.applyList = this.applyList.concat(
          res.data.data.map((d) => ({
            ...d,
            time: d.time.replace(/t/i, " ").substr(0, 16),
          }))
        );
      } catch (e) {
        this.$toast(e);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.mint-search-list {
  display: none !important;
}

.container {
  background: #fff;

  .mint-search {
    height: 44px;
    overflow: hidden;

    ::v-deep .mint-search-list {
      display: none;
    }
  }
  ::v-deep .mint-loadmore-top {
    display: none;
  }
  .scroll-cells {
    height: 100%;
    overflow: scroll;
  }

  .loadmore {
    height: calc(100vh - 145px);
    overflow: scroll;
  }

  .cell-title {
    display: flex;
    align-items: center;
    padding: 15px 0;

    .logo {
      height: 50px;
      width: 50px;
      border-radius: 50%;
    }

    .wrapper {
      display: flex;
      flex-direction: column;
      padding: 0 0 0 15px;

      .title {
        margin: 0 0 10px 0;
      }

      .desc {
        font-size: 0.8em;
        color: #ccc;
      }
    }
  }

  .bottom-loading {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    position: relative;
    width: 100%;
    bottom: 0;
    font-size: 14px;
    background: #fff;

    .text {
      margin-left: 5px;
      color: #ccc;
    }
  }
}
</style>
